export const createDefaultNotification = () => ({
  id: "",
  name: "",
  url: "",
  active: false,
  popUp: {
    headline: "Need help with this page?",
    subheadline: "Our AI assistant can help you navigate this page",
    primaryButtonText: "Get AI Help",
    secondaryButtonText: "No Thanks",
    aiPrompt: "The user is viewing the page at {url}. Help them navigate and find what they need."
  }
});
